import {Routes} from "@angular/router";
import {SignUpComponent} from "./component/sign-up/sign-up.component";
import {RegistrationOtpComponent} from "./component/registration-otp/registration-otp.component";
import {RegistrationPage} from "./page/registration/registration.page";
import {registrationGuard} from "./guard/registration.guard";
import {RegistrationSuccessComponent} from "./component/registration-success/registration-success.component";
import {PostActivitiesComponent} from "./component/post-activities-component/post-activities.component";
export function RgSubRoutes() : Routes {

  /**
   *
   * path:
   * Prefix of the module will always be added to the path name
   *
   *      Example
   *      path: "addresses" => route path "ad/addresses" !
   * ------------------------------------------------------------------
   *
   * component:
   * Added components need to be from type "Page"!
   * ------------------------------------------------------------------
   *
   */
  const routes: Routes = [

    // {path: 'ns/config', component: NsNotificationTypePage},
    {path: 'sign-up', component: SignUpComponent},
    {path: 'sign-up/otp', component: RegistrationOtpComponent, canActivate: [registrationGuard]},

    { path: 'registration/success', component: RegistrationSuccessComponent},
    { path: 'registration', redirectTo: 'registration/1', pathMatch: 'full'},
    { path: 'registration/:step', component: RegistrationPage, canActivate: [registrationGuard] },
    { path: 'post-activity', component: PostActivitiesComponent },

  ];

  return routes;

}
